import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import './logout.css';
import { useNavigate } from 'react-router-dom';

const ModalProfile = ({ isOpen, onClose, onLogout }) => {
  const username = localStorage.getItem('id');
  const [user] = useState(username);
  const navigate = useNavigate();
  if (!isOpen) return null;

  const handleLogoutClick = () => {
    localStorage.clear();
    onLogout();
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <FontAwesomeIcon icon={faUser} className="profile-image" />
          <p className="profile-role"> {user}</p>
        </div>
        <div className="modal-buttons">
          <button
            className="modal-button profile-button"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/Profile`);
            }}>
            <FontAwesomeIcon icon={faUser} className="fa-icon" /> Perfil
          </button>
          <button
            className="modal-button logout-button"
            onClick={handleLogoutClick}
          >
            <FontAwesomeIcon icon={faSignOutAlt} className="fa-icon" /> Cerrar Sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalProfile;
